import { VueRegistration } from "@abaco/web-common/src/app";

const globals: VueRegistration = {
    SingleTileContainer: () => import("./components/SingleTileContainer.vue"),
    FerreroFixedDashboardGrid: () => import("./components/private/FerreroFixedDashboardGrid.vue"),
    FerreroFixedDashboardCell: () => import("./components/private/FerreroFixedDashboardCell.vue"),
    FerreroFixedDashboardTopBarTabs: () => import("./components/private/FerreroFixedDashboardTopBarTabs.vue"),
    DoubleTileContainerLeft4on6: () => import("./components/DoubleTileContainerLeft4on6.vue"),
    FerreroAgreementsListTile: () => import("./components/views/agreements/list/AgreementsListTile.vue"),
    FerreroAgreementsEditTile: () => import("./components/views/agreements/AgreementsEditTile.vue"),
    FerreroAgreementsDetailTile: () => import("./components/views/agreements/detail/AgreementsDetailTile.vue"),
    SCRegionSelectNavBarItem: () => import("./components/navbar/SCRegionSelectionNavBarItem.vue"),
    SCProvinceSelectNavBarItem: () => import("./components/navbar/SCProvinceSelectionNavBarItem.vue"),
};

export default globals;
